var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ManuelContent',{attrs:{"hero":"","src":"/docs/manuel-utilisateur.md"}})
}
var staticRenderFns = []

export { render, staticRenderFns }